export const RESET = 'AUDIO_LIST_RESET';
export const SET_ITEMS = 'AUDIO_LIST_SET_ITEMS';
export const SET_ERROR = 'AUDIO_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'AUDIO_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'AUDIO_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'AUDIO_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/audio/list/mutation_types.js